import { useState } from 'react';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { copyText } from '../../utils/copyText';
import './CopyButton.scss';

export default function CopyButton({ value, label = 'Копировать' }) {
    const [copied, setCopied] = useState(false);

    if (!value) return null;

    const handleCopy = async () => {
        await copyText(String(value));
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <button
            type="button"
            className="copy-btn"
            onClick={handleCopy}
            title={label}
            aria-label={label}
        >
            {copied ? <IconCheck size={16} stroke={2} /> : <IconCopy size={16} stroke={1.5} />}
        </button>
    );
}
